import Vue from "vue";
import Ai from '../components/AI/index.vue'


Vue.component('ai-element', Ai);